import React from 'react';
import PropTypes from 'prop-types';

import { StyledStack, Label, Required, Error } from './styles';

export const CampaignLandingElementWrapper = ({
  required = false,
  isValid = false,
  isTouched = false,
  label = '',
  children
}) => {
  if (!children) return <></>;

  return (
    <StyledStack invalid={required && !isValid}>
      <Label>
        {label}
        {required && <Required>*</Required>}
      </Label>
      {children}
      {required && isTouched && !isValid && <Error>This field is required</Error>}
    </StyledStack>
  );
};

CampaignLandingElementWrapper.propTypes = {
  required: PropTypes.bool,
  isValid: PropTypes.bool,
  isTouched: PropTypes.bool,
  label: PropTypes.string,
  children: PropTypes.node
};

export default CampaignLandingElementWrapper;



// WEBPACK FOOTER //
// ./src/vp-ui/components/CampaignLandingElementWrapper/CampaignLandingElementWrapper.jsx